import React from 'react';
import {useSidebar} from '@src/components/shadcn/sidebar';
import cn from '@src/util/cnHelper';

export const PageWrapper: React.FC = ({children}) => {
  const {isMobile} = useSidebar();
  return (
    <div className={cn('flex flex-auto overflow-hidden', isMobile ? 'flex-col' : 'flex-row')}>
      {children}
    </div>
  );
};

export const ContentWraper: React.FC = ({children}) => {
  const {isMobile, openMobile} = useSidebar();
  return (
    <div
      className={cn(
        'min-w-0 max-w-full flex-1 w-full',
        isMobile ? 'fixed top-12 h-[calc(100%-48px)]' : 'h-screen',
        isMobile && openMobile ? 'overflow-hidden' : ''
      )}
    >
      {children}
    </div>
  );
};

export const NavWrapper: React.FC = ({children}) => {
  const {isMobile} = useSidebar();
  return (
    <div
      className={cn(
        'flex flex-wrap w-[16rem] ',
        isMobile
          ? 'h-12 w-full fixed inset-0'
          : 'w-[--sidebar-width] border-0 border-r border-solid border-peppercorn-200'
      )}
    >
      {children}
    </div>
  );
};
